import { render, staticRenderFns } from "./QueueTip.vue?vue&type=template&id=375be289&scoped=true&"
import script from "./QueueTip.vue?vue&type=script&lang=js&"
export * from "./QueueTip.vue?vue&type=script&lang=js&"
import style0 from "./QueueTip.vue?vue&type=style&index=0&id=375be289&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375be289",
  null
  
)

export default component.exports